<template>
    <div class="menu">
        <img alt="Logo" src="../assets/logonavbar.png">
        <div class="menu-links">
            <a href="#Intro">Inicio</a>
            <a href="#AboutMe">Descripción</a>
            <a href="#Experience">Experiencia</a>
            <a href="#Technologies">Tecnologías</a>
            <a href="#Projects">Proyectos</a>
        </div>
        
        <a  href="#Contact" class="contact">Contacto</a>
    </div>

</template>
  
<script>
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .menu{
        font-family: Roboto;
        display: flex;
        position: fixed;
        height: 10vh;
        width: 100dvw;
        justify-content: space-between;
        align-items: center;
        background-color: #faf3e1;
        z-index: 10;
        
    }
    .menu img{
        width: 50px;
        margin: 1vw 0 1vw 3vw;
        
    }
    .menu-links a{
        margin: 0 10px;
        text-decoration: none;
        color: black;
        padding: 5px 12px;
    }
    .menu-links a:hover{
        border: #34322c 1px solid;
        border-radius: 20px;
        padding: 5px 11px;

    }
    .contact{
        padding: 10px 20px;
        background-color: #34322c;
        color: white;
        border: none;
        border-radius: 20px;
        cursor: pointer;
        margin: 1vw 3vw 1vw 0;
        text-decoration: none;
    }
        
</style>